import type { AxiosInstance } from "axios"
import createAxiosClient from "./api/util/createAxiosInstance"
import { GenesisCareEchoClient } from "./Echo.GenesisCare.Client"
import { SpireEchoClient } from "./Echo.Spire.Client"
import { echoUrl } from "mco-typescript-core/src/url/host"

class EchoClient {
	private axiosClient: AxiosInstance

	constructor() {
		this.axiosClient = createAxiosClient(echoUrl)

		this.genesisCare = new GenesisCareEchoClient(this.axiosClient)
		this.spire = new SpireEchoClient(this.axiosClient)
	}

	public genesisCare: GenesisCareEchoClient
	public spire: SpireEchoClient
}

const echoClient = new EchoClient()

export default echoClient
